module.exports = "/images/page.png?13efa9a0975df7bfd521c5782c90ae3d";